import AmexShopSmallEditorial from './AmexShopSmallEditorial';

export default AmexShopSmallEditorial;
